<template>
  <select class="filter-select form-control" v-model="selected" multiple>
    <option
      v-for="term in terms"
      :key="term.value"
      :selected="selected.indexOf(term.value) !== -1"
      :value="term.value"
      :disabled="term.count === 0 && selected.indexOf(term.value) === -1"
    >
      <span class="mr-2">{{ term.label }}</span>
      <small class="filter-bucket-size font-weight-bold">{{ term.count }}</small>
    </option>
  </select>
</template>

<script>
  import $ from 'jquery'
  import 'select2'
  import 'select2/dist/js/i18n/ru'
  import { isEqual, debounce } from 'lodash'
  import FilterTerms from './filter-terms.vue'

  export default {
    name: 'FilterSelect',
    extends: FilterTerms,
    data: function () {
      return {
        select2Defaults: {
          escapeMarkup: function (markup) { return markup }, // let our custom formatter work
          templateResult: (item) => {
            if (item.loading) return item.text
            if (item.label && item.count !== undefined) {
              return `<div class="d-flex align-items-center justify-content-between">
                        <span class="mr-2">${item.label}</span>
                        <small class="filter-bucket-size font-weight-bold">${item.count}</small>
                      </div>`
            }
            if (item.element) {
              return item.element.innerHTML
            }
          },
          templateSelection: (item) => {
            if (item.label && item.count !== undefined) {
              return `<div class="d-flex align-items-center justify-content-between">
                        <span class="mr-2">${item.label}</span>
                        <small class="filter-bucket-size font-weight-bold">${item.count}</small>
                      </div>`
            }
            if (item.element) {
              return item.element.innerHTML
            }
          },
        },
      }
    },
    computed: {
      $$el () {
        return $(this.$el)
      },
      select2Options () {
        return this.select2Defaults
      },
    },
    mounted () {
      this.initSelect2()
      this.$$el.on('change', this.onChange)
    },
    methods: {
      initSelect2 () {
        this.$$el.select2(this.select2Options)
      },
      destroySelect2 () {
        this.$$el.select2('destroy')
      },
      onTermsChange (newTerms, oldTerms) {
        // Recreate select2 to pick up updated options
        if (!isEqual(newTerms, oldTerms)) {
          this.$nextTick(() => {
            const keepHeight = this.$$el.parent().css('height')
            const restoreHeight = this.$el.parentNode.style.height
            this.$$el.parent().css('height', keepHeight)
            this.destroySelect2()
            this.initSelect2()
            this.$$el.parent().css('height', restoreHeight)
          })
        }
      },
      onChange () {
        this.updateSelected()
      },
      updateSelected: debounce(function () {
        this.selected = this.$$el.val()
      }, 10),
    },
    watch: {
      value (input) {
        if (input.length === 0) {
          this.$$el.empty().trigger('change')
        }
      },
      terms (newTerms, oldTerms) {
        this.onTermsChange(newTerms, oldTerms)
      },
    },
    beforeDestroy () {
      this.destroySelect2()
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/filter-select.vue